var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar-brand',{staticClass:"mr-5",on:{"click":_vm.doRedirect}},[_c('riskhub-logo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }